import { ChangeDetectionStrategy, Component, type OnInit, inject, signal, OnDestroy, computed, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { CloudApiService } from '@/cloud/services/cloud-api.service';
import { MessagesPanelComponent } from '@/shared/messages-panel/messages-panel.component';
import { Message, parseMessages } from 'src/api/messages';

@Component({
  selector: 'app-messages',
  standalone: true,
  imports: [CommonModule, MessagesPanelComponent],
  templateUrl: './messages.html',
  styleUrl: './messages.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Messages implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private api = inject(CloudApiService);
  // Breadcrumbs removed - handled by parent device component
  private deviceId: string | null = null;
  // Live device signal bridged from API stream
  private liveDevice = signal<any | null>(null);
  messages = signal<Message[]>([]);
  initialLoading = signal<boolean>(true);
  private deviceSub?: any;
  private idSet = new Set<string>();

  // Derived computed for count (example usage in template later)
  messageCount = computed(() => this.messages().length);

  constructor() {
    effect(() => {
      const count = this.messageCount();
      // eslint-disable-next-line no-console
      console.log('[Messages] messageCount changed:', count);
    });
    effect(() => {
      const msgs = this.messages();
      // eslint-disable-next-line no-console
      console.log('[Messages]', msgs);
    });
  }

  ngOnInit(): void {
    // Parent route holds :deviceId param
    this.deviceId = this.route.parent?.snapshot.paramMap.get('deviceId') || this.route.snapshot.paramMap.get('deviceId');
    if (!this.deviceId) {
      return;
    }
    // Fetch initial device (one-shot) then subscribe to live updates
    this.api.getDevice(this.deviceId)
      .then(d => {
        this.seedMessagesFromDevice(d);
      })
      .catch(() => { })
      .finally(() => this.initialLoading.set(false));

    // Subscribe to live device snapshots for updates
    this.deviceSub = this.api.subscribeToDevice(this.deviceId).subscribe(d => {
      this.liveDevice.set(d);
      this.seedMessagesFromDevice(d);
    });
  }

  ngOnDestroy(): void {
    try { this.deviceSub?.unsubscribe(); } catch { /* ignore */ }
  }

  // Breadcrumb builder removed

  private seedMessagesFromDevice(device: any | null) {
    if (!device) return;

    this.messages.set(parseMessages(device.payload?.messages || []));
  }

  // TrackBy can be index since we are not enforcing ids
  trackByMessage = (index: number) => index;

}
